'use client';
import Line from '@/components/common/Line';

interface FeatureProps {
    icon: string;
    title: string;
    description: string;
    alt: string;
}

const Feature = ({ icon, title, description, alt }: FeatureProps) => (
    <div className="flex flex-row gap-4 sm:gap-5 lg:gap-[30px] items-start w-full">
        <img
            src={icon}
            alt={alt}
            className="w-10 h-10 sm:w-12 sm:h-12 lg:w-[50px] lg:h-[50px] flex-shrink-0"
        />
        <div className="flex flex-col gap-1 sm:gap-1.5 lg:gap-[2px] flex-1">
            <h3 className="text-lg sm:text-xl lg:text-4xl text-text-primary font-semibold leading-6 sm:leading-7 lg:leading-6xl">
                {title}
            </h3>
            <p className="text-base sm:text-lg lg:text-xl text-text-muted font-medium leading-5 sm:leading-6 lg:leading-xl">
                {description}
            </p>
        </div>
    </div>
)

export default function FeaturesSection() {
    const features: FeatureProps[] = [
        {
            icon: '/images/img_frame_black_900_50x50.svg',
            title: 'Free Shipping',
            description: 'On orders above ₹250',
            alt: 'Free Shipping Icon'
        },
        {
            icon: '/images/img_frame_50x50.svg',
            title: 'Easy Returns',
            description: '30 days return policy',
            alt: 'Easy Returns Icon'
        },
        {
            icon: '/images/img_frame_1.svg',
            title: 'Secure Payment',
            description: '100% secure payment',
            alt: 'Secure Payment Icon'
        },
        {
            icon: '/images/img_frame_2.svg',
            title: '24/7 Support',
            description: 'Dedicated support',
            alt: '24/7 Support Icon'
        }
    ]

    return (
        <section className="w-full -mt-12 sm:-mt-16 lg:-mt-[86px] relative z-10">
            <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px]">
                <div className="w-full max-w-[1804px] mx-auto bg-background-main rounded-xl sm:rounded-2xl lg:rounded-[20px] shadow-sm p-6 sm:p-8 lg:p-[46px]">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-0">
                        {features.map((feature, index) => (
                            <div key={index} className="flex items-center">
                                {index > 0 && (
                                    <Line className="hidden lg:block w-[1px] h-[58px] bg-background-neutral mr-8 lg:mr-[56px]" />
                                )}
                                <Feature {...feature} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}